jQuery(document).ready(function ($) {

  var $targetClass = '.component-card';
  var $triggerClass = '.component-clickarea';

  $($triggerClass)
    .mouseenter(function(){
      setStateParentCard(this);
    })
    .mouseleave(function(){
      setStateParentCard(this);
    });

    var setStateParentCard = function(trigger){
      $target = $(trigger).closest($targetClass);
      $target.toggleClass('is-highlighted');
    };

});